export const TEXT_INPUT_TYPES = {
    TEXT: "text",
    PASSWORD: "password",
};
